module.exports = __webpack_public_path__ + "static/media/experience.f156eb34.png";